import { Box, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTranslate } from "react-admin";

import { color, space } from "../theme/designTokens";
import { Granularity, Interval, INTERVAL_OPTIONS } from "./utils";

export const AnalyticsFilterBar = ({
  interval,
  dateFrom,
  dateTo,
  granularity,
  latestDate,
  granularityDisabled,
  onIntervalChange,
  onDateFromChange,
  onDateToChange,
  onGranularityChange,
}: {
  interval: Interval;
  dateFrom: string;
  dateTo: string;
  granularity: Granularity;
  latestDate?: string;
  granularityDisabled?: boolean;
  onIntervalChange: (interval: Interval) => void;
  onDateFromChange: (date: string) => void;
  onDateToChange: (date: string) => void;
  onGranularityChange: (granularity: Granularity) => void;
}) => {
  const t = useTranslate();

  return (
    <Box sx={{ display: "flex", gap: space.sm, mb: space.lg, flexWrap: "wrap", alignItems: "center" }}>
      <ToggleButtonGroup
        size="small"
        value={interval}
        exclusive
        onChange={(_, v: Interval | null) => {
          if (v !== null) onIntervalChange(v);
        }}
      >
        {INTERVAL_OPTIONS.map(opt => (
          <ToggleButton key={opt} value={opt}>
            {opt === Interval.Custom ? t("analytics.interval.custom") : opt}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {interval === Interval.Custom && (
        <>
          <TextField
            label={t("analytics.from")}
            type="date"
            size="small"
            value={dateFrom}
            onChange={e => {
              if (e.target.value) onDateFromChange(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label={t("analytics.to")}
            type="date"
            size="small"
            value={dateTo}
            onChange={e => {
              if (e.target.value) onDateToChange(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
          />
        </>
      )}
      <ToggleButtonGroup
        size="small"
        value={granularity}
        exclusive
        disabled={granularityDisabled}
        onChange={(_, v: Granularity | null) => {
          if (v !== null) onGranularityChange(v);
        }}
      >
        <ToggleButton value={Granularity.Day}>{t("analytics.granularity.day")}</ToggleButton>
        <ToggleButton value={Granularity.Month}>{t("analytics.granularity.month")}</ToggleButton>
        <ToggleButton value={Granularity.Year}>{t("analytics.granularity.year")}</ToggleButton>
      </ToggleButtonGroup>
      {latestDate && (
        <Typography variant="body2" sx={{ color: color.secondary40, ml: "auto" }}>
          {t("analytics.latest", { date: latestDate })}
        </Typography>
      )}
    </Box>
  );
};
